import React from 'react';
import styles from './delete-confirm.module.sass';
import { Modal } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

export const confirmDelete = ({ onOk, onCancel }) => {
  Modal.confirm({
    className: styles.container,
    title: 'Are you sure you want to delete this?',
    icon: <DeleteOutlined />,
    content: 'You can’t undo this action!',
    onOk() {
      onOk();
    },
    onCancel() {
      onCancel && onCancel();
    },
    okText: 'Delete',
    cancelText: 'Close',
    cancelButtonProps: {
      type: 'default',
    },
    okButtonProps: {
      danger: true,
    },
  });
};
